import { Dialog } from "@headlessui/react"
import React, { FC, useEffect, useState } from "react"
import { X } from "heroicons-react"
import { User } from "../../../../../types"
import { KButton, KDropdown, KSpan, KTitleSpan } from "kahuna-base-react-components"
import { users } from "../../../../../apis"
import { toast } from "react-toastify"
import { currencyOptions, errorFilledToastOptions, successFilledToastOptions } from "../../../../../constants"

type AdminUserCurrencySelectionModalProps = {
  open: boolean
  onClose: () => void
  user: User | null
  userId: number | undefined
  selectedCurrencyId: number | undefined
}
const AdminCurrencySelectionModal: FC<AdminUserCurrencySelectionModalProps> = (props) => {
  const { onClose, open, selectedCurrencyId } = props
  const onCloseModal = () => {
    onClose()
    setCurrencyId(selectedCurrencyId)
  }

  const [currencyId, setCurrencyId] = useState<number | undefined>(selectedCurrencyId)

  useEffect(() => {
    setCurrencyId(selectedCurrencyId)
  }, [selectedCurrencyId])

  const updateUserAdvanceCurrency = () => {
    users(`/update_user_advance_currency/`, "POST", { currency_id: currencyId, user: props.userId })
      .then((resp) => {
        if (resp.data.success) {
          toast.success("User advance currency updated successfully.", successFilledToastOptions)
        } else {
          toast.error("An error occurred while updating the currencies.", errorFilledToastOptions)
        }
        onClose()
      })
      .catch(() => {
        toast.error("An error occurred while updating the currencies.", errorFilledToastOptions)
        onClose()
      })
  }

  const onApprove = () => {
    if (currencyId !== selectedCurrencyId) {
      updateUserAdvanceCurrency()
    } else {
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={() => onCloseModal()} className="relative">
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div>
          <div className={`flex justify-end`}>
            <X className="h-4 cursor-pointer mt-1" style={{ position: "absolute" }} onClick={() => onCloseModal()} />
          </div>

          <div className="bg-white elev-b-sm rounded-lg" style={{ overflowY: "auto", padding: 42 }}>
            <KTitleSpan text={"Change Advance Currency"} fontSize={24} lineHeight="24px" />
            <div className="flex items-center gap-1 pt-7">
              <KSpan text="User:" fontWeight={500} color="#000" />
              <KSpan text={`${props?.user?.firstName} ${props?.user?.lastName}`} color="#000" />
            </div>
            <div className="py-7 pb-14">
              <KDropdown
                placeholder="TRY"
                width={80}
                menuWidth={80}
                height={44}
                options={currencyOptions}
                selected={currencyOptions.find((option) => option.value === currencyId)}
                onSelect={(selected: any) => {
                  if (selected) {
                    setCurrencyId(selected.value)
                  }
                }}
                rightIcon="/admin_icons/caret-down.svg"
                enableIndicator
              />
            </div>

            <div className="flex pt-6" style={{ borderTop: "1px solid rgb(220 220 220)" }}>
              <KButton text="Cancel" background="white" shadowDisabled={true} onClick={onCloseModal} />
              <KButton text="Confirm" background="black" textColor="white" onClick={onApprove} />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default AdminCurrencySelectionModal
